// Trialing accounts get the nav's TrialIndicator instead, so no callout is
// offered to them here; that keeps a duplicate trial CTA out of the sidebar.
export function calloutMap(user) {
  if (
    !user ||
    user.onTrial ||
    !user.canViewAccountSettings ||
    !user.show_upgrade_callout
  ) {
    return []
  }

  const serviceLevel = user.access_level?.service_level

  const calloutMapping = {
    NewsletterUpgradeCallout: {
      openPlanComparison: true,
      planComparisonModalContent: {
        title: "Level up from scrappy to sophisticated with the Creator Plan",
        description:
          "Explore our plans to access powerful automation tools that'll give you back time and scale your business",
        plans: ["creator", "creator_pro"]
      },
      calloutLink: null,
      calloutContent: {
        header: "Save time with automations",
        text: "Explore our plans to access powerful automation tools that’ll give you back time and help you scale your business.",
        buttonText: "Learn more",
        trackEvent: "main-menu-upgrade-newsletter"
      }
    },
    creatorProCallout: {
      openPlanComparison: true,
      planComparisonModalContent: {
        title: "Maximize monetization with Pro-level audience insights",
        description:
          "Access premium analytics and conversion optimization tools to scale to 6-figures and beyond",
        plans: ["creator_pro"],
        prioritizedPlan: "creator_pro"
      },
      calloutLink: null,
      calloutContent: {
        header: "Level up your marketing",
        text: `Upgrade to Pro for an extra ${user.creator_pro_pricing_display} to access even more powerful tools to scale your business.`,
        buttonText: "Learn more",
        trackEvent: "main-menu-upgrade-creator-pro"
      }
    },
    creatorUpgradeCallout: {
      openPlanComparison: true,
      planComparisonModalContent: {
        title: "Level up from scrappy to sophisticated with the Creator Plan",
        description:
          "Explore our plans to access powerful automation tools that'll give you back time and scale your business",
        plans: ["creator", "creator_pro"]
      },
      calloutLink: null,
      calloutContent: {
        header: "Ready to automate your work?",
        text: "Upgrade to the Creator Plan to access powerful automation tools to scale your business.",
        buttonText: "Learn more",
        trackEvent: "main-menu-upgrade-creator"
      }
    }
  }

  let calloutVariant
  if (serviceLevel === "newsletter_free") {
    calloutVariant = "NewsletterUpgradeCallout"
  } else if (
    serviceLevel !== "creator_free" &&
    (user.pro_is_purchasable || user.switch_trial_to_pro)
  ) {
    calloutVariant = "creatorProCallout"
  } else if (serviceLevel === "creator_free") {
    calloutVariant = "creatorUpgradeCallout"
  } else {
    return []
  }

  const callout = calloutMapping[calloutVariant]

  return [
    true,
    callout.calloutLink,
    callout.calloutContent,
    callout.openPlanComparison,
    callout.planComparisonModalContent
  ]
}
